import { PiiEmailNoCoborrower, PiiEmailWithCoborrower } from '../../cards/pii-email';
import { Branch, Card } from '../../components/deck';

export const hasCoborrowerWithAcceptedOfferBranch = (continuation) =>
  Branch(
    {
      singleBorrower: Card(PiiEmailNoCoborrower),
      withCoborrower: Card(PiiEmailWithCoborrower)
    },
    ({ model }) => (model.getIn(['loan', 'hasCoborrower']) ? 'withCoborrower' : 'singleBorrower'),
    continuation
  );



// WEBPACK FOOTER //
// ./src/decks/branches/has-coborrower-with-accepted-offer.js